"use client"

import { useState, useEffect } from "react"

export function useMobile(breakpoint = 768): boolean {
  const query = `(max-width: ${breakpoint - 1}px)`

  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return false
    return window.matchMedia(query).matches
  })

  useEffect(() => {
    const media = window.matchMedia(query)
    const listener = (event: MediaQueryListEvent) => setIsMobile(event.matches)
    media.addEventListener("change", listener)
    setIsMobile(media.matches)
    return () => media.removeEventListener("change", listener)
  }, [query])

  return isMobile
}
